// extracted by mini-css-extract-plugin
export default {"ignore":"ignore_ignore__eGiLN"};